module.exports = __webpack_public_path__ + "static/media/sfondoServizi1.51eea67b.jpg";